import { render, staticRenderFns } from "./AmateurMatchSection.vue?vue&type=template&id=653f359e&"
import script from "./AmateurMatchSection.vue?vue&type=script&lang=js&"
export * from "./AmateurMatchSection.vue?vue&type=script&lang=js&"
import style0 from "./AmateurMatchSection.vue?vue&type=style&index=0&id=653f359e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports